var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"top-bar"},[_c('img',{staticClass:"app-logo",attrs:{"src":_vm.Logo,"alt":"contrend-logo"}}),_c('app-user-avatar',{attrs:{"name":_vm.username,"email":_vm.user.email,"profile-picture":_vm.user.picture}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }